import { GraphUtils } from '@helpers/graph.helper';
import { Sensor } from '../sensor/sensor';
import { Router } from '@angular/router';
import { UtilsHelper } from '@helpers/utils.helper';

export class AtmPressureAttribute extends Sensor {
  public atmPressureChart: any;
  private atmPressureSensor: any[];
  public iconsToDisplay: { icon: string, type: number }[] = [];

  constructor(router: Router, url: string, alertsActive: boolean) {
    super(router, url, alertsActive);
    this.atmPressureChart = null;
    this.atmPressureSensor = [];
  }

  private ensureArraySize(arr: any[], position: number): void {
    while (arr.length <= position) {
      arr.push([]);
    }
  }

  public prepareData(): void {
    const iconMap = new Map<string, { icon: string, type: number }>();
    for (const element of this.data) {
      const date = new Date(element.date);
      const timestamp = GraphUtils.getDateUtc(date);
      const position = element.position;
      const sensorInfo = UtilsHelper.nameSensor(element.type);
      const icon = sensorInfo.icon; 
      if (!iconMap.has(icon)) {
        iconMap.set(icon, {
          icon,
          type: element.type
        });
      }

      this.ensureArraySize(this.atmPressureSensor, position);
      this.atmPressureSensor[position].push([timestamp, element.atmPressure]);
    }
    this.iconsToDisplay = Array.from(iconMap.values());
  }

  public setCharts(): void {
    const filteredAtmPressure = this.atmPressureSensor.filter(series => series.length > 0);

    const positionNodeAtmPressure = this.atmPressureSensor
      .map((item, index) => (item.length > 0 ? index + 1 : -1))
      .filter(index => index !== -1);

    this.atmPressureChart = this.getConfigChar(
      'atmPressure',
      this.getChartSeriesNewNode('Sensor', filteredAtmPressure, positionNodeAtmPressure),
      this.getRanges('atmPressure'),
      this.getLimits('atmPressure')
    );
  }

  public hasAtmPressureSensor(pos: number): boolean {
    const index = pos - 1;
    return (
      index >= 0 &&
      index < this.atmPressureSensor.length &&
      this.atmPressureSensor[index].length > 0
    );
  }

  public getAtmPressureSensor(pos: number): any {
    const index = pos - 1;
    if (index >= 0 && index < this.atmPressureSensor.length) {
      const sensorData = this.atmPressureSensor[index];
      if (sensorData.length > 0) {
        return sensorData[sensorData.length - 1][1] ?? null;
      }
    }
    return null;
  }

  public static getVariables(): any[] {
    return [
      { title: 'Presión Atmosférica', value: 'atmPressure' }
    ];
  }
}
